<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_30945"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16763_30945)">
      <path
        d="M12.625 5.25C13.6783 5.25 14.205 5.25 14.5834 5.5028C14.7471 5.61223 14.8878 5.75286 14.9972 5.91664C15.25 6.29498 15.25 6.82165 15.25 7.875V15C15.25 16.4142 15.25 17.1213 14.8107 17.5607C14.3713 18 13.6642 18 12.25 18H7.75C6.33579 18 5.62868 18 5.18934 17.5607C4.75 17.1213 4.75 16.4142 4.75 15V7.875C4.75 6.82165 4.75 6.29498 5.0028 5.91664C5.11223 5.75286 5.25286 5.61223 5.41664 5.5028C5.79498 5.25 6.32165 5.25 7.375 5.25"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M7.75 5.25C7.75 4.42157 8.42157 3.75 9.25 3.75H10.75C11.5784 3.75 12.25 4.42157 12.25 5.25C12.25 6.07843 11.5784 6.75 10.75 6.75H9.25C8.42157 6.75 7.75 6.07843 7.75 5.25Z"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M7.75 10.5L12.25 10.5"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M7.75 13.5L10.75 13.5"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
